var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"core-loader"},[_c('div',{staticClass:"stream_spiner"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }